import { ClienteDTO, EncuestaDTO, EnvioDTO, InvestigacionDTO, PaisDTO, TagDTO } from "@DTOS";
import { Nilable } from "@shared/utils";
import { DatosActualizarInvestigacion } from "./clases";

export namespace InvestigacionesAcciones {
    export class CargarClientes {
        static readonly type = "[Investigaciones] Cargar clientes";
        constructor(public clientes: ClienteDTO[]) {}
    }

    export class Obtener {
        static readonly type = "[Investigaciones] Obtener";
        constructor(public cantidad: number, public activas: boolean = true) {}
    }

    export class ObtenerMas {
        static readonly type = "[Investigaciones] Obtener mas";
        constructor(public cantidad: number, public pagina: number) {}
    }

    export class Buscar {
        static readonly type = "[Investigaciones] Buscar";
        constructor(public cantidad: number, public termino: string, public activas: boolean = true) {}
    }

    export class BuscarMas {
        static readonly type = "[Investigaciones] Buscar mas";
        constructor(public cantidad: number, public pagina: number) {}
    }

    export class ObtenerId {
        static readonly type = "[Investigaciones] Obtener por id";
        constructor(public id: number) {}
    }

    export class Agregar {
        static readonly type = "[Investigaciones] Agregar";

        constructor(public investigacion: InvestigacionDTO, public paises: PaisDTO[]) {}
    }

    export class ObtenerCuotas {
        static readonly type = "[Investigaciones] Obtener cuotas";
        constructor(public investigacion: InvestigacionDTO) {}
    }

    export class ObtenerFunnels {
        static readonly type = "[Investigaciones] Obtener funnels";
        constructor(public investigacion: InvestigacionDTO, public envio: EnvioDTO) {}
    }

    export class ObtenerMarcadores {
        static readonly type = "[Investigaciones] Obtener marcadores";
        constructor(public investigacion: InvestigacionDTO, public envio: EnvioDTO) {}
    }

    export class ObtenerPreguntas {
        static readonly type = "[Investigaciones] Obtener preguntas";
        constructor(public investigacion: InvestigacionDTO, public encuesta: EncuestaDTO) {}
    }

    export class ObtenerRespuestasDia {
        static readonly type = "[Investigaciones] Obtener respuestas del dia";
        constructor(public investigacion: InvestigacionDTO, public envio: EnvioDTO) {}
    }

    export class ObtenerRespuestas {
        static readonly type = "[Investigaciones] Obtener respuestas";
        constructor(public investigacion: InvestigacionDTO, public encuesta: EncuestaDTO) {}
    }

    export class ObtenerGrupos {
        static readonly type = "[Investigaciones] Obtener grupos";
        constructor(public investigacion: InvestigacionDTO) {}
    }

    export class Actualizar {
        static readonly type = "[Investigaciones] Actualizar";
        constructor(public investigacion: Nilable<InvestigacionDTO>, public datos: DatosActualizarInvestigacion) {}
    }

    export class CargarEtiquetas {
        static readonly type = "[Investigaciones] Cargar etiquetas";
        constructor(public etiquetas: TagDTO[]) {}
    }

    export class ReiniciarRespuestas {
        static readonly type = "[Investigaciones] Reiniciar respuestas";
    }

    export class Salir {
        static readonly type = "[Investigaciones] Salir";
    }

    export class SacarSeleccionada {
        static readonly type = "[Investigaciones] Sacar seleccionada";
    }
}
